import React, { useEffect, useState } from "react";
import "../css/LandingPage.css";

export default function KWListingsCTA() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };

    document.addEventListener("keydown", onKeyDown);
    // Prevent background scroll while modal is open
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  const handleHomeValueClick = () => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) {
      window.open(
        "https://kentuckyhomeliving.kw.com/home-value-tool",
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      setOpen(true);
    }
  };


  return (
    <section className="landing-section light" id="home-valuation">
      <div className="interior-inner" style={{ maxWidth: 980, margin: "0 auto" }}>
        <h2>Home Valuation</h2>
        
        <p>Home valuation is the process of estimating a property's current market value, typically for purposes such as buying, selling, refinancing or taxation</p>

        <p className="landing-section-intro" style={{ maxWidth: 720, margin: "0 auto" }}>
          Get a quick estimate powered by Keller Williams—then I can help you interpret it and plan next steps.
        </p>

        <div className="card-grid" style={{ marginTop: "1.5rem" }}>
          <div className="ui-card">
            <h4>Get My Home Value</h4>
            <p>
              Enter your address to see an instant estimate based on current market data.
            </p>

            <div style={{ marginTop: "1rem" }}>
              <button
                type="button"
                className="btn primary"
                onClick={handleHomeValueClick}
              >
                Start Home Valuation
              </button>

            </div>
          </div>

          <div className="ui-card">
            <h4>Want a More Accurate Number?</h4>
            <p>
              I’ll run a personalized market analysis with recent comps and upgrades taken into account.
            </p>

            <div style={{ marginTop: "1rem" }}>
              <a className="btn secondary" href="/contact">
                Request a CMA
              </a>
            </div>
          </div>
        </div>

        <p className="mock-note" style={{ textAlign: "center", marginTop: "1.25rem" }}>
          Valuation tool provided by Keller Williams Realty.
        </p>
      </div>

      {/* Modal */}
      {open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Home Valuation Tool"
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.55)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "min(1100px, 100%)",
              height: "min(82vh, 820px)",
              background: "#fff",
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Modal header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 14px",
                borderBottom: "1px solid rgba(0,0,0,0.08)",
              }}
            >
              <div style={{ fontWeight: 700 }}>Home Valuation</div>

              <button
                type="button"
                className="btn secondary"
                onClick={() => setOpen(false)}
                style={{ padding: "8px 12px" }}
              >
                Close
              </button>
            </div>

            {/* Iframe */}
            <div style={{ flex: 1 }}>
              <iframe
                src="https://kentuckyhomeliving.kw.com/home-value-tool"
                title="KW Home Value Tool"
                width="100%"
                height="100%"
                style={{ border: "none" }}
                loading="lazy"
                allow="geolocation"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
